module.exports = __webpack_public_path__ + "static/media/avatar_16.24d98495.svg";